import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { translate } from '../../../../utils/util';
import InventoryListLot from './InventoryGeneralListLot';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS } from '../../../../utils/constants';
import * as lineInventoryAction from '../../../../actions/inventoryAction';
import { Title, Subtitle, BackButton } from '../../../../components/UI/ComponentsUI';

const LotGeneral = (props) => {
    const filterRoute = props.location?.state;
    const [allLots, setAllLots] = useState(
        (filterRoute?.byFilter && filterRoute?.byFilterLot) || !checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.ConnectLotUser : PERMISSIONS.Inventory.Rotative.ConnectLotUser)
            ? true
            : props.filter.allLots
    );

    useEffect(() => {
        props.selectedFilterLotAll(allLots);
        // eslint-disable-next-line
    }, []);

    const onClick = (set) => {
        setAllLots(set);
        props.selectedFilterLotAll(set);
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-check-outline" label={translate('inventory', 'inventory')} />
                <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('general.menu.lot', 'inventory')} />
                {
                    checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.ConnectLotUser : PERMISSIONS.Inventory.Rotative.ConnectLotUser)
                    && (
                        <div className="title" style={{ float: 'right', margin: '10px' }}>
                            <Link
                                className="row"
                                to="../general/userLot"
                                style={{ display: 'block', marginBottom: '0px' }}
                            >
                                <i className="material-icons">group</i>
                            </Link>
                        </div>
                    )
                }
                {
                    checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.ConnectLotUser : PERMISSIONS.Inventory.Rotative.ConnectLotUser)
                    && (
                        <div className="title" style={{ float: 'right', margin: '10px' }}>
                            <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => onClick(allLots ? false : true)}>{allLots ? 'visibility' : 'visibility_off'} </i>
                        </div>
                    )
                }
            </div>
            <div className="container-fluid" style={{ marginTop: '20px', }}>
                <InventoryListLot data={props} allLots={allLots} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        selectedFilterLotAll: (allLots) => {
            dispatch(lineInventoryAction.setSelectedFilterLotAll(allLots));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LotGeneral)));
